export const originalTheme = Object.freeze({
  context: {
    'gradient': true,
    'shadow': 'lg', // 3 states: 'sm', 'lg', undefined (no shadow).
    'invertedColor': false,
  },
  colors: {
    primary: '#82b140',
    secondary: '#82b140',
    success: '#82b140',
    info: '#82b140',
    danger: '#82b140',
    warning: '#82b140',
    gray: '#82b140',
    dark: '#82b140',
  },
})

export const corporateTheme = Object.freeze({
  context: {
    'gradient': false,
    'shadow': 'sm',
    'invertedColor': true,
  },
  colors: {
    primary: '#82b140',
    secondary: '#82b140',
    success: '#82b140',
    info: '#82b140',
    danger: '#82b140',
    warning: '#82b140',
    gray: '#82b140',
    dark: '#82b140',
  },
})
